import { FC } from 'react';
import { Dropdown, DropdownListItem, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import { ApplicationTheme } from 'shared/themes';
import { ApprovedIcon } from 'shared/icons/ApprovedIcon';
import { useTheme } from 'styled-components';
import {
  DropdownText,
  LonglistChoiceButton,
  LonglistFormationActions,
  LonglistFormationNominationRow,
  LonglistFormationTitle,
  LonglistFormationNavRow,
  LonglistFormationVoteMainRow,
  LonglistFormationVotePanel,
  LonglistFormationVoteTextCol,
} from './styles';

const NextStepIcon: FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.158 8L4.22347 13.7402C3.92551 14.0284 3.92551 14.4957 4.22348 14.7839C4.52144 15.0721 5.00453 15.072 5.30249 14.7838L11.7765 8.52183C12.0745 8.23363 12.0745 7.76637 11.7765 7.47817L5.30249 1.21615C5.00453 0.927951 4.52144 0.927949 4.22348 1.21615C3.92551 1.50435 3.92551 1.97161 4.22347 2.25981L10.158 8Z"
      fill="currentColor"
    />
  </svg>
);

export type LonglistFormationVoteSectionProps = {
  nominationTitle: string;
  competitionTabs: Record<string, string>;
  activeTabKey?: string;
  onTabChange: (tab: string) => void;
  voteValue: number;
  isLoading: boolean;
  loaderVisible: boolean;
  onPickValue: (value: number) => void;
  onNext: () => void;
  onPrev: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
};

export const LonglistFormationVoteSection: FC<LonglistFormationVoteSectionProps> = ({
  nominationTitle,
  competitionTabs,
  activeTabKey,
  onTabChange,
  voteValue,
  isLoading,
  loaderVisible,
  onPickValue,
  onNext,
  onPrev,
  isPrevDisabled = false,
  isNextDisabled = false,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const themeWhite = ApplicationTheme.white;

  const tabsCount = Object.keys(competitionTabs).length;

  return (
    <LonglistFormationVotePanel direction="column" directionMobile="column" width="100%" widthMobile="100%">
      <LonglistFormationVoteMainRow direction="row">
        <LonglistFormationVoteTextCol>
          <LonglistFormationNominationRow>
            {tabsCount > 1 ? (
              <Dropdown
                offsetY={5}
                hideArrow
                orientation="left"
                maxWidth={480}
                target={
                  <ArrowTopIconWithText
                    text={nominationTitle}
                    shrimpIcon
                    fill="#909090"
                    fullLineText
                  />
                }
              >
                {Object.keys(competitionTabs).map((key) => (
                  <div
                    key={key}
                    onClick={() => {
                      if (key === activeTabKey) return false;
                      onTabChange(key);
                    }}
                  >
                    <DropdownListItem justify="space-between" isActive={key === activeTabKey}>
                      <DropdownText isActive={key === activeTabKey}>{competitionTabs[key]}</DropdownText>
                      <ApprovedIcon fill={themeWhite.icon.active} display={key === activeTabKey} />
                    </DropdownListItem>
                  </div>
                ))}
              </Dropdown>
            ) : (
              <ArrowTopIconWithText text={nominationTitle} shrimpIcon fill="#909090" fullLineText />
            )}
          </LonglistFormationNominationRow>
          <LonglistFormationTitle>{t('project.longlist_vote.add_to_longlist')}</LonglistFormationTitle>
        </LonglistFormationVoteTextCol>
        <LonglistFormationActions
          align="stretch"
          alignMobile="stretch"
          width="100%"
          direction="row"
          directionMobile="row"
        >
          <LonglistChoiceButton
            type="button"
            $selected={voteValue === 0}
            $voteTone="no"
            disabled={isLoading || loaderVisible}
            onClick={() => onPickValue(0)}
          >
            {t('no')}
          </LonglistChoiceButton>
          <LonglistChoiceButton
            type="button"
            $selected={voteValue === 1}
            $voteTone="yes"
            disabled={isLoading || loaderVisible}
            onClick={() => onPickValue(1)}
          >
            {t('yes')}
          </LonglistChoiceButton>
        </LonglistFormationActions>
      </LonglistFormationVoteMainRow>
      <LonglistFormationNavRow direction="row">
        <LonglistChoiceButton type="button" disabled={isPrevDisabled || isLoading} onClick={onPrev}>
          {t('prev_competition')}
        </LonglistChoiceButton>
        <LonglistChoiceButton
          type="button"
          disabled={isNextDisabled || isLoading}
          onClick={onNext}
        >
          {t('next_competition')}
          <NextStepIcon />
        </LonglistChoiceButton>
      </LonglistFormationNavRow>
    </LonglistFormationVotePanel>
  );
};
import { FC } from 'react';
import { Dropdown, DropdownListItem, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import { ApplicationTheme } from 'shared/themes';
import { ApprovedIcon } from 'shared/icons/ApprovedIcon';
import { useTheme } from 'styled-components';
import {
  DropdownText,
  LonglistChoiceButton,
  LonglistFormationActions,
  LonglistFormationNominationRow,
  LonglistFormationTitle,
  LonglistFormationNavRow,
  LonglistFormationVoteMainRow,
  LonglistFormationVotePanel,
  LonglistFormationVoteTextCol,
} from './styles';

const NextStepIcon: FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.158 8L4.22347 13.7402C3.92551 14.0284 3.92551 14.4957 4.22348 14.7839C4.52144 15.0721 5.00453 15.072 5.30249 14.7838L11.7765 8.52183C12.0745 8.23363 12.0745 7.76637 11.7765 7.47817L5.30249 1.21615C5.00453 0.927951 4.52144 0.927949 4.22348 1.21615C3.92551 1.50435 3.92551 1.97161 4.22347 2.25981L10.158 8Z"
      fill="currentColor"
    />
  </svg>
);

export type LonglistFormationVoteSectionProps = {
  nominationTitle: string;
  competitionTabs: Record<string, string>;
  activeTabKey?: string;
  onTabChange: (tab: string) => void;
  voteValue: number;
  isLoading: boolean;
  loaderVisible: boolean;
  onPickValue: (value: number) => void;
  onNext: () => void;
  onPrev: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
};

export const LonglistFormationVoteSection: FC<LonglistFormationVoteSectionProps> = ({
  nominationTitle,
  competitionTabs,
  activeTabKey,
  onTabChange,
  voteValue,
  isLoading,
  loaderVisible,
  onPickValue,
  onNext,
  onPrev,
  isPrevDisabled = false,
  isNextDisabled = false,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const themeWhite = ApplicationTheme.white;

  const tabsCount = Object.keys(competitionTabs).length;

  return (
    <LonglistFormationVotePanel direction="column" directionMobile="column" width="100%" widthMobile="100%">
      <LonglistFormationVoteMainRow direction="row">
        <LonglistFormationVoteTextCol>
          <LonglistFormationNominationRow>
            {tabsCount > 1 ? (
              <Dropdown
                offsetY={5}
                hideArrow
                orientation="left"
                maxWidth={480}
                target={
                  <ArrowTopIconWithText
                    text={nominationTitle}
                    shrimpIcon
                    fill="#909090"
                    fullLineText
                  />
                }
              >
                {Object.keys(competitionTabs).map((key) => (
                  <div
                    key={key}
                    onClick={() => {
                      if (key === activeTabKey) return false;
                      onTabChange(key);
                    }}
                  >
                    <DropdownListItem justify="space-between" isActive={key === activeTabKey}>
                      <DropdownText isActive={key === activeTabKey}>{competitionTabs[key]}</DropdownText>
                      <ApprovedIcon fill={themeWhite.icon.active} display={key === activeTabKey} />
                    </DropdownListItem>
                  </div>
                ))}
              </Dropdown>
            ) : (
              <ArrowTopIconWithText text={nominationTitle} shrimpIcon fill="#909090" fullLineText />
            )}
          </LonglistFormationNominationRow>
          <LonglistFormationTitle>{t('project.longlist_vote.add_to_longlist')}</LonglistFormationTitle>
        </LonglistFormationVoteTextCol>
        <LonglistFormationActions
          align="stretch"
          alignMobile="stretch"
          width="100%"
          direction="row"
          directionMobile="row"
        >
          <LonglistChoiceButton
            type="button"
            $selected={voteValue === 0}
            $voteTone="no"
            disabled={isLoading || loaderVisible}
            onClick={() => onPickValue(0)}
          >
            {t('no')}
          </LonglistChoiceButton>
          <LonglistChoiceButton
            type="button"
            $selected={voteValue === 1}
            $voteTone="yes"
            disabled={isLoading || loaderVisible}
            onClick={() => onPickValue(1)}
          >
            {t('yes')}
          </LonglistChoiceButton>
        </LonglistFormationActions>
      </LonglistFormationVoteMainRow>
      <LonglistFormationNavRow direction="row">
        <LonglistChoiceButton type="button" disabled={isPrevDisabled || isLoading} onClick={onPrev}>
          {t('prev_competition')}
        </LonglistChoiceButton>
        <LonglistChoiceButton
          type="button"
          disabled={isNextDisabled || isLoading}
          onClick={onNext}
        >
          {t('next_competition')}
          <NextStepIcon />
        </LonglistChoiceButton>
      </LonglistFormationNavRow>
    </LonglistFormationVotePanel>
  );
};
